module.exports = __webpack_public_path__ + "static/media/calendar-grey.01f1742f.svg";